// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1gYHj","noInteraction":"EventWrapper_noInteraction__qn6TF","pointerPassthrough":"EventWrapper_pointerPassthrough__9ZRYc"};